const host =  'http://3.144.143.71' 
const hostreport = 'http://3.144.143.71'

module.exports = {
    conexion: host+':2100',
    imagenes: host+':2300',
    cne: host+':2200',
    reportes: hostreport+':4000/paez?',
    email: hostreport+':5000',
    alcaldia:'Alcaldía del Municipio Paez',
    correo: 'alcaldiadelmunicipiopaez@gmail.com',
    rif: 'G-20002730-4'
}


//////////////////
// WEBPACK FOOTER
// ./public/modulos/datos.js
// module id = 1062
// module chunks = 0